import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from "vuex-persistedstate";

// import example from './module-example'
import shopping_cart_store from './modules/shopping-cart'
import app_settings from './modules/app-settings'
import globalization from './modules/globalization'
import planner from './modules/planner'
import current_session from './modules/current-session'
import identity from './modules/identity'

Vue.use(Vuex)

/*
 * If not building with SSR mode, you can
 * directly export the Store instantiation;
 *
 * The function below can be async too; either use
 * async/await or return a Promise which resolves
 * with the Store instance.
 */

//export default function (/* { ssrContext } */) {
//  const Store = new Vuex.Store({
//    modules: {
//      shopping_cart_store,
//      app_settings,
//      globalization
//    },
//    plugins: [createPersistedState()],
//    // enable strict mode (adds overhead!)
//    // for dev mode only
//    strict: process.env.DEBUGGING
//  })

//  return Store
//}
export default new Vuex.Store({
    modules: {
        shopping_cart_store,
        globalization,
        app_settings,
        planner,
        current_session,
        identity
    },
    plugins: [createPersistedState()],
    // enable strict mode (adds overhead!)
    // for dev mode only
    strict: process.env.DEBUGGING
})
